import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutExchangeRateList extends Layout {
    layoutheaderExchangeRateList: LayoutHeader;
    sourceCurrencyExchange: DataSource;
    tableExchangeRates: Table;
}
